import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["buttons"]

  static values = {
    activeYear: Number,
    minYear: Number,
    maxYear: Number
  }

  connect() {
    this.activeYear = this.clamp(
      this.activeYearValue || new Date().getFullYear(),
      this.minYearValue,
      this.maxYearValue
    )

    this.startYear = this.clamp(
      this.activeYear - 2,
      this.minYearValue,
      Math.max(this.minYearValue, this.maxYearValue - 4)
    )

    this.render()
  }

  render() {
    this.buttonsTarget.innerHTML = ""

    const currentUrl = new URL(window.location.href)

    for (let year = this.startYear; year <= this.maxYearValue && year < this.startYear + 5; year++) {
      const params = new URLSearchParams(currentUrl.search)
      params.set("year", year)

      const btn = document.createElement("a")
      btn.href = `${currentUrl.pathname}?${params.toString()}`
      btn.setAttribute("data-turbo-frame", "_top")

      btn.className = `btn ${
        year === this.activeYear
          ? "btn-primary active"
          : "btn-outline-primary"
      }`

      btn.textContent = year
      this.buttonsTarget.appendChild(btn)
    }
  }

  prev() {
    this.startYear = Math.max(this.minYearValue, this.startYear - 5)
    this.render()
  }

  next() {
    const latestStart = Math.max(this.minYearValue, this.maxYearValue - 4)
    this.startYear = Math.min(latestStart, this.startYear + 5)
    this.render()
  }

  clamp(value, min, max) {
    return Math.min(Math.max(value, min), max)
  }
}